import { createFileRoute } from "@tanstack/react-router";
import {
  EventDetailView,
  buildEventMeta,
  loadEventMeta,
} from "@/components/event-detail-view";

// Public, share-friendly URL: brulo.fit/evento/[id].
// Renders the same detail view and OG metadata as /eventos/$eventId
// so WhatsApp / social crawlers get a rich preview directly.
export const Route = createFileRoute("/evento/$eventId")({
  loader: async ({ params }) => ({ meta: await loadEventMeta(params.eventId) }),
  head: ({ params, loaderData }) =>
    buildEventMeta(loaderData?.meta ?? null, `https://brulo.fit/evento/${params.eventId}`),
  component: () => {
    const { eventId } = Route.useParams();
    return <EventDetailView eventId={eventId} />;
  },
});
